import React from "react";
import { ArrowRight } from "lucide-react";
import Particles from "@/components/Particles";

const BG = "https://images.unsplash.com/photo-1639322537228-f710d846310a?auto=format&fit=crop&w=1600&q=80";

export default function FinalCTA({ onJoin }) {
    return (
        <section
            id="rejoindre"
            className="relative py-28 sm:py-36 overflow-hidden text-white"
            data-testid="finalcta-section"
        >
            <div
                className="absolute inset-0 bg-cover bg-center"
                style={{ backgroundImage: `url(${BG})` }}
                aria-hidden
            />
            <div
                className="absolute inset-0"
                style={{
                    background:
                        "linear-gradient(135deg, rgba(10,10,15,0.92) 0%, rgba(108,71,255,0.45) 100%)",
                }}
                aria-hidden
            />
            <Particles
                color="#A78BFA"
                linkColor="#6C47FF"
                density={0.00007}
                maxParticles={40}
            />
            <div className="absolute -top-40 left-1/3 w-[640px] h-[640px] rounded-full bg-cap-violet/40 blur-[140px]" />
            <div className="absolute -bottom-40 right-0 w-[460px] h-[460px] rounded-full bg-cap-gold/20 blur-[140px]" />

            <div className="relative max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
                <p className="fade-up eyebrow text-white/70">
                    Prochaine étape
                </p>
                <h2
                    className="fade-up h-display text-3xl sm:text-5xl lg:text-[64px] font-bold mt-4 tracking-tight"
                    style={{ animationDelay: "0.05s" }}
                    data-testid="finalcta-title"
                >
                    Prêt à développer ton{" "}
                    <span className="text-violet-glow">portefeuille B2B</span> ?
                </h2>
                <p
                    className="fade-up mt-7 text-lg text-white/75 max-w-2xl mx-auto leading-relaxed"
                    style={{ animationDelay: "0.1s" }}
                >
                    Rejoins CapDistrib et commence à générer des revenus
                    récurrents sur la distribution digitale.
                </p>

                <div
                    className="fade-up mt-10 flex flex-col items-center gap-3"
                    style={{ animationDelay: "0.15s" }}
                >
                    <button
                        onClick={onJoin}
                        className="btn-gold px-10 py-4 rounded-full text-base inline-flex items-center gap-2"
                        data-testid="finalcta-button"
                    >
                        Candidater maintenant
                        <ArrowRight size={18} />
                    </button>
                    <p className="text-[13px] text-white/60 mt-1">
                        Réponse sous 48h — Aucun engagement initial.
                    </p>
                </div>
            </div>
        </section>
    );
}
